import { Box } from '@/ui/primitives';
import type { PropsWithChildren, ReactElement } from 'react';

type PolicyPageShellProps = PropsWithChildren;

export const PolicyPageShell = ({ children }: PolicyPageShellProps): ReactElement => (
  <Box
    component="main"
    sx={{
      minHeight: '100dvh',
      backgroundColor: 'var(--surface-page)',
    }}
  >
    {children}
  </Box>
);
